// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"a6272803","703":"de3972af"}[chunkId] + ".chunk.js";
};